<template>
  <div id="measure-list">
    <v-container>
      <v-card>
        <v-card-text>
          <div class="headline">計測一覧</div>
          <div class="actions my-5">
            <v-btn
              color="success"
              class="mr-3"
              @click="openCreateModal"
              v-if="admin"
              tile
            >
              <span class="font-weight-bold">新しい計測を開始する</span>
            </v-btn>
            <OutlinedTiledBtn
              :disabled="selected.length === 0"
              :to="{
                name: 'MeasureEdit',
                params: { id: selected.length !== 0 ? selected[0].id : 0 },
              }"
            >
              <v-icon left>mdi-pencil</v-icon>
              <span class="font-weight-bold">編集</span>
            </OutlinedTiledBtn>
          </div>

          <v-data-table
            :headers="headers"
            :items="measureList"
            :items-per-page="999"
            hide-default-footer
            show-select
            single-select
            v-model="selected"
            sort-by="name"
          >
            <template v-slot:[`header.site_group`]>
              <th class="text-left" v-if="admin">グループ名</th>
            </template>
            <template v-slot:[`item.device`]="{ item }">
              <td>{{ item.device.uid }}</td>
            </template>
            <template v-slot:[`item.start_at`]="{ item }">
              <td>{{ formatDate(item.start_at) }}</td>
            </template>
            <template v-slot:[`item.site_group`]="{ item }">
              <td v-if="admin">
                {{ item.site_group ? item.site_group.name : "" }}
              </td>
            </template>
            <template v-slot:[`item.action`]="{ item }">
              <td>
                <v-btn
                  :to="{ name: 'MeasureGraph', params: { id: item.id } }"
                  color="indigo"
                  class="white--text"
                  >グラフ</v-btn
                >
              </td>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-container>

    <measure-create-modal
      :modal="modal"
      :deviceIds="deviceIds"
      :siteGroups="siteGroups"
      @close="closeCreateModal"
      @submit="handleSubmitModal"
    ></measure-create-modal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import MeasureCreateModal from "@/components/MeasureCreateModal";
import OutlinedTiledBtn from "@/components/OutlinedTiledBtn";

import api from "@/api";
import Measure from "@/models/measure";
import dayjs from "dayjs";

export default {
  name: "measure-list",
  components: { MeasureCreateModal, OutlinedTiledBtn },
  data() {
    return {
      modal: false,
      headers: [
        { text: "計測名称", value: "name" },
        { text: "説明", value: "description" },
        { text: "デバイスID", value: "device" },
        { text: "計測開始日", value: "start_at" },
        { text: "グループ名", value: "site_group" },
        { text: "", value: "action" },
      ],
      selected: [],
    };
  },
  computed: {
    ...mapGetters("user", { admin: "isAdmin" }),
    measureList() {
      return this.$store
        .$db()
        .model("measures")
        .query()
        .withAll()
        .orderBy("start_at", "desc")
        .get();
    },
    deviceIds() {
      return this.$store
        .$db()
        .model("devices")
        .all()
        .map((device) => device.uid);
    },
    siteGroups() {
      return this.$store
        .$db()
        .model("site_groups")
        .all();
    },
  },
  methods: {
    openCreateModal() {
      this.modal = true;
    },
    closeCreateModal() {
      this.modal = false;
    },
    handleSubmitModal(form) {
      const params = {
        device_id: form.deviceId,
        measure: {
          mode: form.mode,
          name: form.name,
          description: form.description,
          template_type: form.template_type,
        },
        site_group: { name: form.siteGroup },
      };
      api.measures.create(params).then((data) => Measure.insert({ data }));
      this.modal = false;
    },
    formatDate(string) {
      return dayjs(string).format("YYYY/MM/DD HH:mm:ss");
    },
  },
};
</script>

<style scoped>
.v-data-table {
  white-space: nowrap;
}
</style>
